import { cn } from '../utils';
import { Platform, TextInput } from 'react-native';

function Input({
  className,
  ...props
}: React.ComponentProps<typeof TextInput> & React.RefAttributes<TextInput>) {
  return (
    <TextInput
      className={cn(
        'flex h-12 w-full min-w-0 flex-row items-center rounded-xl border border-white/25 bg-black/35 px-4 py-2 font-sans text-base leading-5 text-white shadow-none sm:h-11',
        props.editable === false &&
          cn(
            'opacity-50',
            Platform.select({ web: 'disabled:pointer-events-none disabled:cursor-not-allowed' })
          ),
        Platform.select({
          web: cn(
            'outline-none transition-[color,box-shadow] selection:bg-primary selection:text-primary-foreground placeholder:text-white/50 md:text-sm',
            'focus-visible:border-primary focus-visible:ring-[3px] focus-visible:ring-primary/35',
            'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive'
          ),
          native: 'placeholder:text-white/50',
        }),
        className
      )}
      {...props}
    />
  );
}

export { Input };
